import React, { useEffect, useState, useRef } from "react";
import { PiGift } from "react-icons/pi";
import { PiUsers } from "react-icons/pi";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { fetchData } from "../../../Components/common/utils";
const Counter = () => {
  const [adsCount, setAdsCount] = useState(0);
  const [usersCount, setUsersCount] = useState(0);
  const [verifiedCount, setVerifiedCount] = useState(0);
  const hasStartedRef = useRef(false);
  const counterSectionRef = useRef(null);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchApiData = async () => {
      const url = "api/counter/list";
      const result = await fetchData(url);
      if (result) {
        setData(result.data);
      }
      setLoading(false);
    };
    fetchApiData();
  }, []);

  const incrementCounter = (target, setter, duration) => {
    let start = 0;
    const step = Math.ceil(target / (duration / 100));
    const stepTime = 100;

    const timer = setInterval(() => {
      start += step;
      if (start >= target) {
        setter(target);
        clearInterval(timer);
      } else {
        setter(start);
      }
    }, stepTime);
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasStartedRef.current && data) {
          hasStartedRef.current = true;
          incrementCounter(Number(data.published_add), setAdsCount, 2000);
          incrementCounter(Number(data.registered_user), setUsersCount, 2000);
          incrementCounter(Number(data.verified), setVerifiedCount, 2000);
        }
      },
      { threshold: 0.5 }
    );

    if (counterSectionRef.current) {
      observer.observe(counterSectionRef.current);
    }

    return () => {
      if (counterSectionRef.current) {
        observer.unobserve(counterSectionRef.current);
      }
    };
  }, [data]);

  return (
    <section className="counter" ref={counterSectionRef}>
      <div className="elementor-background-overlay"></div>
      <div className="container">
        <div className="row counter-icon d-flex justify-content-space-between">
          <div className="col-md-4 d-flex gap-3 counter-gap align-items-center z-1 justify-content-center">
            <PiGift className="counter-icons" />
            <div
              className={`text-white text-center align-items-center gap-2 ${
                loading ? "d-flex flex-column" : ""
              }`}
            >
              {loading && (
                <div className="spinner-border theme-clr" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {!loading && <h2>{adsCount}+</h2>}

              <strong>Published Ads</strong>
            </div>
          </div>
          <div className="col-md-4 d-flex gap-3 counter-gap align-items-center z-1 justify-content-center">
            <PiUsers className="counter-icons" />
            <div
              className={`text-white text-center align-items-center gap-2 ${
                loading ? "d-flex flex-column" : ""
              }`}
            >
              {loading && (
                <div className="spinner-border theme-clr" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {!loading && <h2>{usersCount}+</h2>}
              <strong>Registered Users</strong>
            </div>
          </div>
          <div className="col-md-4 d-flex gap-3 counter-gap align-items-center z-1 justify-content-center">
            <MdOutlineVerifiedUser className="counter-icons" />
            <div
              className={`text-white text-center align-items-center gap-2 ${
                loading ? "d-flex flex-column" : ""
              }`}
            >
              {loading && (
                <div className="spinner-border theme-clr" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
              {!loading && <h2>{verifiedCount}+</h2>}
              <strong>Verified</strong>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Counter;
